module.exports = __webpack_public_path__ + "static/media/user_l.9cf25707.svg";